// Affiche / masque un champ mot de passe (bouton œil).
export const PasswordToggle = (() => {
	const SELECTOR = ".js-password-toggle";

	const labels = {
		show: "Afficher le mot de passe",
		hide: "Masquer le mot de passe",
	};

	const toggle = (button) => {
		const input = document.getElementById(button.dataset.target);
		if (!input) return;

		const willShow = input.type === "password";

		input.type = willShow ? "text" : "password";
		button.setAttribute("aria-pressed", String(willShow));
		button.setAttribute("aria-label", willShow ? labels.hide : labels.show);
	};

	const init = () => {
		const buttons = document.querySelectorAll(SELECTOR);
		if (!buttons.length) return;

		buttons.forEach((button) => button.addEventListener("click", () => toggle(button)));
	};

	return { init };
})();
